"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _addDevelopmentInfoToWindow = require("./addDevelopmentInfoToWindow");
Object.keys(_addDevelopmentInfoToWindow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addDevelopmentInfoToWindow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addDevelopmentInfoToWindow[key];
    }
  });
});
